import React from 'react';
interface DoctrinePredictionTableProps {
  data: {
    day: string;
    soldiers: number;
    perishableRate: number;
    nonPerishableRate: number;
    totalBoxes: number;
    resupply?: boolean;
    boxesLeft: number;
    capacity: number;
    percentLeft: number;
  }[];
  onResupplyChange?: (day: string, checked: boolean) => void;
}
export const DoctrinePredictionTable: React.FC<DoctrinePredictionTableProps> = ({
  data,
  onResupplyChange
}) => {
  return <div className="overflow-x-auto bg-white border border-gray-200 rounded-md" data-id="element-703">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-704">
        <thead className="bg-gray-50" data-id="element-705">
          <tr data-id="element-706">
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-707">
              Day
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-708">
              # Soldiers
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-709">
              Perishable Box Usage Rate
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-710">
              Non-perishable Box Usage Rate
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-711">
              Total Boxes Consumed/Day
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-712">
              Resupply
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-713">
              Boxes Left
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-714">
              Capacity
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-715">
              Predicted % Left On Hand
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-716">
          {data.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-717">
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900" data-id="element-718">
                {row.day}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-719">
                {row.soldiers}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-720">
                {row.perishableRate}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-721">
                {row.nonPerishableRate}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm" data-id="element-722">
                <div className="bg-gray-100 border border-gray-300 rounded px-3 py-1 text-black font-bold inline-block" data-id="element-723">
                  {row.totalBoxes}
                </div>
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 text-center" data-id="element-724">
                <input type="checkbox" checked={row.resupply || false} onChange={e => onResupplyChange && onResupplyChange(row.day, e.target.checked)} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer" data-id="element-725" />
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-726">
                {row.boxesLeft}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-727">
                {row.capacity}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700" data-id="element-728">
                {row.percentLeft.toFixed(1)}%
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
};